module.exports = __webpack_public_path__ + "img/logo_line_blanc.bfa54a5f.png";